import React, { useState } from 'react';
import { useMedia } from 'react-use';
import clsx from 'clsx';

import Portal from '@srcDS/components/atoms/portal';
import styles from '@srcDS/components/organisms/productGallery/ProductGallery.module.scss';
import '@srcDS/components/organisms/productGallery/ProductGallery.global.scss';

import LightBox from '@srcDS/components/organisms/productGallery/LightBox';
import MobileGallery from '@srcDS/components/organisms/productGallery/galleryViewPort/MobileGallery';
import DesktopGallery from '@srcDS/components/organisms/productGallery/galleryViewPort/DesktopGallery';

const ProductGallery = React.memo((props) => {
  const isMobile = useMedia('(max-width: 767px)', false);
  const [zoomItem, setZoomItem] = useState({
    enabled: false,
    mainImage: null,
  });
  const {
    images,
    text,
    textAuthor,
    isDemo,
    className,
    alt,
    isSelectingSize,
    variant,
    customClasses,
    isSSR,
    productOverlayUrl,
  } = props;
  const Component = isMobile ? MobileGallery : DesktopGallery;

  return (
    <div className={clsx(styles.galleryWrapper, className)}>
      <Component
        isDemo={isDemo}
        setZoomItem={setZoomItem}
        images={images}
        isMobile={isMobile}
        text={text}
        textAuthor={textAuthor}
        alt={alt}
        customClasses={customClasses}
        isSSR={isSSR}
        isSelectingSize={isSelectingSize}
        variant={variant}
        productOverlayUrl={productOverlayUrl}
      />
      {zoomItem && zoomItem.enabled && (
        <Portal>
          <LightBox
            onClose={setZoomItem}
            images={images}
            zoomItem={zoomItem}
            alt={alt}
            isSSR={isSSR}
            productOverlayUrl={productOverlayUrl}
          />
        </Portal>
      )}
    </div>
  );
});

export default ProductGallery;
